import a, { forwardRef as H, createElement as Q, useState as T, useEffect as U, useCallback as L, useMemo as $, useRef as S, useId as X, useImperativeHandle as Y } from "react";
import { t as P, c as v } from "./app-a75c1d35.mjs";
import { b as Z } from "./useClickOutside-726e7c36.mjs";
import { I as O, W as R } from "./Icon-3122c134.mjs";
import { a as A } from "./index-615eb227.mjs";
const ee = "dropdown", te = "dropdown__button", oe = "dropdown__count-badge", ne = "dropdown__button--large", se = "dropdown__button--disabled", re = "dropdown__filter", ae = "mobile", de = "dropdown__list", le = "desktop", ce = "dropdown__list-item", ue = "dropdown__list-empty-message", ie = "dropdown__checkbox", pe = "dropdown__label-content", me = "dropdown__button--open", f = {
  dropdown: ee,
  dropdownButton: te,
  dropdownCountBadge: oe,
  dropdownButtonLarge: ne,
  dropdownButtonDisabled: se,
  dropdownFilter: re,
  mobile: ae,
  dropdownList: de,
  desktop: le,
  dropdownListItem: ce,
  dropdownListEmptyMessage: ue,
  dropdownCheckbox: ie,
  dropdownLabelContent: pe,
  dropdownButtonOpen: me
}, we = H(function({
  isOpen: e,
  selectedItems: t,
  label: n,
  onClick: s,
  isLarge: d,
  isMulti: i,
  className: l,
  ...u
}, p) {
  const k = t.length, m = A(
    (b) => {
      b.stopPropagation(), s?.(b);
    }
  ), { disabled: x } = { ...u }, h = typeof n == "string" ? /* @__PURE__ */ a.createElement(
    "label",
    {
      className: e ? P.textsLeadTextBold : P.textsLeadText
    },
    i ? /* @__PURE__ */ a.createElement("span", { className: f.dropdownLabelContent }, n, k > 0 ? /* @__PURE__ */ a.createElement(W, { count: k }) : null) : /* @__PURE__ */ a.createElement("span", null, t[0]?.label || n)
  ) : Q(n, { isOpen: e, selectedItems: t, isMulti: i });
  return /* @__PURE__ */ a.createElement(
    "button",
    {
      "data-testid": "dropdown-button",
      "aria-label": n.toString(),
      className: v(
        f.dropdownButton,
        d && f.dropdownButtonLarge,
        x && f.dropdownButtonDisabled,
        e && f.dropdownButtonOpen,
        l
      ),
      type: "button",
      ...u,
      onClick: m,
      ref: p
    },
    h,
    /* @__PURE__ */ a.createElement(
      O,
      {
        icon: e ? R.CHEVRON_UP : R.CHEVRON_DOWN,
        size: 16
      }
    )
  );
}), fe = H(function({
  isOpen: e,
  getItemProps: t,
  checkSelected: n,
  items: s,
  highlightedIndex: d,
  emptyMessage: i,
  isMulti: l,
  className: u,
  name: p,
  showFilterInput: k = !1,
  ...m
}, x) {
  const [h, b] = T(""), _ = h ? s?.filter((r) => {
    if (r && r.label)
      return r.label.toLowerCase().startsWith(h.toLowerCase());
  }) : s, E = (r) => {
    const c = r.target.value, I = c.charAt(0).toUpperCase() + c.slice(1);
    b(I);
  };
  return U(() => {
    e || b("");
  }, [e]), /* @__PURE__ */ a.createElement(a.Fragment, null, e && k && /* @__PURE__ */ a.createElement(
    "input",
    {
      type: "text",
      value: h,
      onChange: E,
      tabIndex: e ? 0 : -1,
      className: v(f.dropdownFilter, P.textsLeadTextBold),
      autoFocus: e
    }
  ), /* @__PURE__ */ a.createElement(
    "ul",
    {
      ...m,
      className: v(f.dropdownList, u),
      ref: x,
      "data-testid": "dropdown-list",
      hidden: !e
    },
    _.length > 0 ? _.map((r, c) => {
      const I = n(r.value);
      return /* @__PURE__ */ a.createElement(
        "li",
        {
          className: f.dropdownListItem,
          "data-highlighted": d === c,
          key: `${r.value}${c}`,
          "aria-selected": I,
          ...t({ item: r.value, index: c }),
          "data-testid": "dropdown-list-item-" + c,
          tabIndex: 0
        },
        l ? /* @__PURE__ */ a.createElement(ge, { checked: I }) : null,
        /* @__PURE__ */ a.createElement(
          "label",
          {
            className: v(
              P.textsLeadText,
              f.dropdownLabelContent
            )
          },
          r.label,
          r.count ? /* @__PURE__ */ a.createElement(W, { count: r.count }) : null
        )
      );
    }) : /* @__PURE__ */ a.createElement("p", { className: f.dropdownListEmptyMessage }, i)
  ), p ? s.map((r) => /* @__PURE__ */ a.createElement(
    "input",
    {
      hidden: !0,
      key: r.value,
      name: p,
      checked: n(r.value),
      value: r.value,
      type: l ? "checkbox" : "radio",
      onChange: he
    }
  )) : null);
});
function ge({ checked: o = !1 }) {
  return /* @__PURE__ */ a.createElement("div", { className: f.dropdownCheckbox, "aria-checked": o }, o && /* @__PURE__ */ a.createElement(O, { icon: R.CHECK }));
}
function W({ count: o }) {
  return /* @__PURE__ */ a.createElement("div", { className: f.dropdownCountBadge, "aria-hidden": "true" }, /* @__PURE__ */ a.createElement("span", { className: P.textsCaption }, o));
}
function he() {
}
function z(o, e) {
  const t = e?.replace(/\s/g, "-").replace(/[^\w]/gi, "");
  return `dropdown-${o}-list-item-${t}`;
}
function be(o, e, t, n) {
  const s = () => t(0), d = () => t(e - 1), i = () => t((u) => Math.min(u + 1, e - 1)), l = () => t((u) => Math.max(0, u - 1));
  if (o.key === "Tab") {
    o.preventDefault(), o.shiftKey ? l() : i();
    return;
  }
  if (o.key === "ArrowDown") {
    o.preventDefault(), o.metaKey ? d() : i();
    return;
  }
  if (o.key === "ArrowUp") {
    o.preventDefault(), o.metaKey ? s() : l();
    return;
  }
  if (o.key === "Enter" || o.key === " ")
    return o.preventDefault(), n();
}
function Ie(o, e) {
  const [t, n] = T(0), s = L(
    () => e[t],
    [e, t]
  ), d = $(
    () => z(o, s()?.value),
    [o, s]
  );
  return {
    highlightedIndex: t,
    highlightedItemId: d,
    setHighlightedIndex: n,
    getItemFromHighlightedIndex: s
  };
}
function Ee(o, e, t, n) {
  const [s, d] = T(!1), i = L(
    (p = 0) => {
      d(!0), n?.(!0), e.current?.focus(), t(p);
    },
    [e, n, t]
  ), l = L(
    (p = !1) => {
      d(!1), n?.(!1), p && o.current?.focus();
    },
    [o, n]
  ), u = A(
    () => s ? l(!0) : i(0)
  );
  return { isOpen: s, openMenu: i, closeMenu: l, toggleMenu: u };
}
function Ce(o, e) {
  const t = T(
    () => new Set(
      (e || o || []).map(
        (s) => s.value
      )
    )
  ), n = t[1];
  return U(() => {
    e && n((s) => (s.clear(), e.forEach((d) => s.add(d.value)), s));
  }, [e, n]), t;
}
function ye(o, e, t) {
  const n = S(!1);
  return U(() => {
    if (t)
      return;
    const s = e.current?.querySelector("#" + o);
    n.current && s?.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth"
    });
  }, [t, o, e]), n;
}
function ke(o) {
  const {
    id: e,
    items: t = [],
    initialSelectedItems: n,
    selectedItems: s,
    enableCloseOnSelect: d = !1,
    onOpenStateChange: i,
    onSelectedItemsChange: l,
    isMulti: u = !0,
    disabled: p
  } = o, k = X(), m = (e || k).replace(/:/g, ""), x = S(null), h = S(null), {
    highlightedIndex: b,
    highlightedItemId: _,
    setHighlightedIndex: E,
    getItemFromHighlightedIndex: r
  } = Ie(m, t), { isOpen: c, closeMenu: I, openMenu: B, toggleMenu: F } = Ee(
    x,
    h,
    E,
    i
  ), D = ye(
    _,
    h,
    !c
  ), [g, N] = Ce(n, s), C = L(
    (w) => g.has(w),
    [g]
  ), K = L(
    (w) => {
      const y = w || r().value;
      if (u) {
        C(y) ? g.delete(y) : g.add(y), N(g);
        const M = t.filter(
          (V) => g.has(V.value)
        );
        l?.(M), d && I(!0);
      } else
        C(y) ? (N(/* @__PURE__ */ new Set()), l?.([])) : (N(/* @__PURE__ */ new Set([y])), l?.(
          t.filter((M) => M.value === y)
        )), I(!0);
    },
    [
      r,
      C,
      g,
      N,
      t,
      l,
      d,
      I,
      u
    ]
  ), q = L(() => ({
    id: `dropdown-${m}-button`,
    ref: x,
    "aria-expanded": c,
    "aria-haspopup": "listbox",
    onClick: F,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => {
      if (D.current = !0, w.key === "ArrowDown")
        return w.preventDefault(), B();
    },
    disabled: p
  }), [m, c, F, p, D, B]), j = L(() => ({
    id: `dropdown-${m}-list`,
    ref: h,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": _,
    "data-open": c,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => (D.current = !0, be(
      w,
      t.length,
      E,
      K
    ))
  }), [
    m,
    _,
    c,
    D,
    t.length,
    E,
    K
  ]), G = L(
    ({ item: w, index: y }) => {
      const M = b === y, V = C(w);
      return {
        id: z(m, w),
        role: "option",
        "aria-selected": V,
        "aria-current": M,
        onClick: () => K(w),
        onMouseEnter: () => E(y),
        onTouchStart: () => E(y)
      };
    },
    [
      b,
      C,
      m,
      K,
      E
    ]
  ), J = $(
    () => t.filter((w) => g.has(w.value)),
    [t, g]
  );
  return {
    uuid: m,
    isOpen: c,
    highlightedIndex: b,
    selectedItemsValues: g,
    selectedItems: J,
    checkSelected: C,
    openMenu: B,
    closeMenu: I,
    getMenuProps: j,
    getMenuItemProps: G,
    getUpdatedToggleButtonProps: q
  };
}
const Me = H(function(e, t) {
  const n = S(null), {
    label: s,
    name: d,
    items: i = [],
    emptyMessage: l = "No items available",
    size: u = "normal",
    isMulti: p = !0,
    className: k,
    buttonClassName: m,
    listClassName: x,
    autoFocus: h = !1,
    showFilterInput: b = !1,
    disabled: _
  } = e, {
    uuid: E,
    isOpen: r,
    highlightedIndex: c,
    selectedItems: I,
    getMenuProps: B,
    getMenuItemProps: F,
    checkSelected: D,
    getUpdatedToggleButtonProps: g,
    openMenu: N,
    closeMenu: C
  } = ke(e);
  return Y(
    t,
    () => ({
      open: N,
      close: C,
      isOpen: r
    }),
    [N, C, r]
  ), Z([n], C, { disabled: !r }), /* @__PURE__ */ a.createElement(
    "div",
    {
      id: `dropdown-${E}`,
      className: v(f.dropdown, k),
      "data-testid": "dropdown",
      ref: n
    },
    /* @__PURE__ */ a.createElement(
      we,
      {
        isOpen: r,
        label: s,
        selectedItems: e.selectedItems || I,
        isLarge: u === "large",
        isMulti: p,
        className: m,
        ...g(),
        autoFocus: h
      }
    ),
    !_ && /* @__PURE__ */ a.createElement(
      fe,
      {
        isOpen: r,
        items: i,
        getItemProps: F,
        checkSelected: D,
        highlightedIndex: c,
        emptyMessage: l,
        isMulti: p,
        className: x,
        name: d,
        ...B(),
        showFilterInput: b
      }
    )
  );
});
function ve() {
  return S(null);
}
export {
  Me as D,
  ve as u
};
//# sourceMappingURL=Dropdown-cd8b285a.mjs.map
